// extracted by mini-css-extract-plugin
export default {"taskCreaterBox":"TaskCreater_taskCreaterBox__14qMb","darkTheme":"TaskCreater_darkTheme__lGnTC","lightTheme":"TaskCreater_lightTheme__35jxa","addIcon":"TaskCreater_addIcon__TdIu0"};